'use client';

import Image from 'next/image';
import { useState } from 'react';

// The image optimizer occasionally returns 500 when its own fetch to the CMS
// hits a transient gateway error; remounting the img re-requests it.
const MAX_LOAD_RETRIES = 2;
const RETRY_DELAY_MS = 1200;

/**
 * The only client-side piece of BaseImage: kept as a leaf component so
 * BaseImage itself stays a server component and full Strapi image objects
 * never cross the server->client boundary — only the derived img props do.
 */
export function RetryingImage(props: React.ComponentProps<typeof Image>) {
  const [attempt, setAttempt] = useState(0);

  return (
    <Image
      key={attempt}
      {...props}
      onError={() => {
        if (attempt < MAX_LOAD_RETRIES) {
          setTimeout(
            () => setAttempt(attempt + 1),
            RETRY_DELAY_MS * (attempt + 1),
          );
        }
      }}
    />
  );
}
